// #region Dependencias
import styled from 'styled-components'
import { Flex } from '..'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledInputLabel = styled.label`
  align-items: center;
  color: ${({ color = 'primary' }) =>
    color === 'primary'
      ? colors.primary
      : color === 'secondary'
      ? colors.secondary
      : color === 'tertiary'
      ? colors.tertiary
      : color === 'dark'
      ? colors.text
      : color};
  border-radius: 100px;
  cursor: help;
  display: flex;
`

const StyledHelper = styled.span`
  background-color: ${({ color = 'primary' }) =>
    color === 'primary'
      ? colors.primary
      : color === 'secondary'
      ? colors.secondary
      : color === 'tertiary'
      ? colors.tertiary
      : color === 'dark'
      ? colors.text
      : color};
  border-radius: 100px;
  color: ${colors.white};
  cursor: help;
  display: inline-block;
  font-size: 0.7rem;
  height: 14px;
  margin-left: 0.25rem;
  text-align: center;
  user-select: none;
  width: 14px;
`

const StyledLengthCounter = styled.small`
  color: ${colors.primary};
`
// #endregion

/**
 * Componente que renderiza una etiqueta con un indicador de longitud maxima
 * y un texto de ayuda para los input.
 *
 * @class
 * @example
 * <InputLabel helper="Ingresar nombre" htmlFor="nombre" label="Nombre" maxLength={40} value="valor" />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.color - Color de la etiqueta del campo.
 * @param {string} [props.helper=null] - Texto de ayuda del campo.
 * @param {string} props.htmlFor - Texto de ayuda del campo.
 * @param {string} props.label - Texto de la etiqueta del campo.
 * @param {number} [props.maxLength=null] - Longitud máxima del texto permitido en el campo.
 * @param {string} props.value - Valor actual del campo.
 */
const InputLabel = ({ helper, htmlFor, label, maxLength, value, ...props }) => {
  return (
    <Flex alignItems="center" justifyContent="space-between">
      <StyledInputLabel htmlFor={htmlFor} {...props}>
        {label}
        {helper && <StyledHelper title={helper}>?</StyledHelper>}
      </StyledInputLabel>
      {maxLength && (
        <StyledLengthCounter>
          {value.length}/{maxLength}
        </StyledLengthCounter>
      )}
    </Flex>
  )
}

export default InputLabel
